<template>
  <div class="filtro k-filtercell">
    <div class="k-filtercell-wrapper">
      <!-- <span
        class="k-widget k-autocomplete k-autocomplete-clearable k-state-default"
      >-->
      <input
        class="k-textbox"
        ref="select"
        type="select"
        :value="value"
        @input="change"
        @keyup.enter="change"
      >
      <!-- </span> -->
      <div class="k-filtercell-operator">
        <select
          v-model="selected"
          class="k-textbox"
          ref="select"
          :value="operator"
          @change="change"
        >
          <option value="Reset">(All)</option>
          <option value="eqt">Is True</option>
          <option value="eqf">Is False</option>
        </select>
        <button
          v-show="visibleFilterBtn"
          ref="button"
          type="button"
          class="k-button k-button-icon k-clear-button-visible"
          @click="reset"
        >
          <span class="k-icon k-i-filter-clear"></span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { Grid } from "@progress/kendo-vue-grid";

export default {
  name: "customBooleanGridComponent",
  data() {
    return {
      visibleFilterBtn: false,
      selected: "Reset"
    };
  },
  props: {
    grid: Grid,
    field: String,
    filterType: String,
    value: [String, Number, Boolean, Date],
    operator: String
  },
  methods: {
    change(ev) {
      var selectValue = "";
      switch (this.$refs.select.value) {
        case "eqt":
          selectValue = "True";
          break;
        case "eqf":
          selectValue = "False";
          break;
      }
      this.$emit("change", {
        operator: "eq",
        field: this.field,
        value: selectValue,
        syntheticEvent: ev
      });
    },
    reset(ev) {
      this.visibleFilterBtn = false;
      this.$emit("change", {
        operator: "Reset",
        field: "",
        value: "",
        syntheticEvent: ev
      });
    }
  }
};
</script>

<style>
.inputStyle {
  border-style: groove;
}
.filtro select {
  -webkit-appearance: menulist;
  border-style: groove;
}
.k-pager-sizes select {
  -webkit-appearance: menulist;
}
/* The container must be positioned relative: */
.custom-select {
  position: relative;
  font-family: Arial;
}

.custom-select select {
  display: none; /*hide original SELECT element: */
}

.select-selected {
  background-color: DodgerBlue;
}

/* Style the arrow inside the select element: */
.select-selected:after {
  position: absolute;
  content: "";
  top: 14px;
  right: 10px;
  width: 0;
  height: 0;
  border: 6px solid transparent;
  border-color: #fff transparent transparent transparent;
}
</style>
